import React from 'react';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';

type Props = {
  trialName?: string;
  isOpen: boolean;
  onClose: () => void;
  isDrt?: boolean;
};

const AlreadyEnrolledWarningDialog: React.FC<Props> = ({
  trialName,
  isOpen,
  onClose,
  isDrt = false,
}: Props) => {
  const navigate = useNavigate();
  const renderActionButtons = () => [
    <Button
      key="no"
      variant="contained"
      onClick={() => onClose()}
      color="secondary"
    >
      <FormattedMessage id="genericCancel" />
    </Button>,
    <Button
      key="yes"
      variant="contained"
      onClick={() => navigate('/enrollments')}
      color="primary"
    >
      <FormattedMessage id="yes" />
    </Button>,
  ];

  return (
    <GenericDialog isOpen={isOpen} actions={renderActionButtons()}>
      <ContentBox
        elevation={0}
        title={<FormattedMessage id="trialsenrolled.warningheadline" />}
      >
        <Typography variant="body1">
          {isDrt ? (
            <FormattedMessage
              id="trialsenrolled.contentDRT"
              values={{ trialName }}
            />
          ) : (
            <FormattedMessage
              id="trialsenrolled.content"
              values={{ trialName }}
            />
          )}
        </Typography>
      </ContentBox>
    </GenericDialog>
  );
};

export default AlreadyEnrolledWarningDialog;
